import { useState, useEffect } from 'react';
// import { reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import cn from 'clsx';
import { jsonValidationStyles } from './jsonValidationStyles';
import Box from '@mui/material/Box';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Divider from '@mui/material/Divider';
import { useDispatch, useSelector } from 'react-redux';
import {
  getValidationResults,
  getCurrentFlowchartId,
  getCurrentTabId,
  setCurrentFlowchartName,
  setCurrentTabId,
  getFlowcharts,
} from '../../../store';
import { styled } from '@mui/material/styles';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { countAndPluralization } from '../utils';

interface VisibilityProps extends IconButtonProps {
  expand: boolean;
}

const Visibility = styled((props: VisibilityProps) => {
  const { expand, ...other } = props;
  return expand ? (
    <IconButton {...other}>
      <VisibilityOffIcon />
    </IconButton>
  ) : (
    <IconButton {...other}>
      <VisibilityIcon />
    </IconButton>
  );
})(({ theme, expand }) => ({
  marginLeft: 'auto',
}));

interface ValidationProps {
  close: any;
}

interface CollapseListProps {
  entries: any;
  header: string;
  headerStyles: any;
  onClick: any;
  listStyles?: any;
}

const CollapseList = ({ entries, header, headerStyles, onClick, listStyles }: CollapseListProps) => {
  const [expanded, setExpanded] = useState(true);
  const classes = jsonValidationStyles();
  return (
    <>
      <div className={cn(classes.flexRow, classes.alignCenter)} style={headerStyles}>
        <b style={{ textAlign: 'center', marginLeft: '15px' }}>{header}</b>
        <Visibility
          expand={expanded}
          onClick={() => {
            setExpanded(!expanded);
          }}
          size="small"
        />
      </div>
      {expanded && (
        <ol>
          {entries.map((error: string, index: number) => {
            return (
              <li key={index} onClick={onClick}>
                {error}
              </li>
            );
          })}
        </ol>
      )}
    </>
  );
};

function JSONValidationComponent({ close }: ValidationProps) {
  const validationResults = useSelector(getValidationResults);
  const allFlowcharts = useSelector(getFlowcharts);
  const dispatch = useDispatch();
  const classes = jsonValidationStyles();
  const [expanded, setExpanded] = useState(true);

  if (
    Object.keys(validationResults).length === 0 ||
    (Object.keys(validationResults).length === 1 && Object.keys(validationResults['claim']).length === 0)
  ) {
    return <></>;
  }
  return (
    <>
      <Box className={classes.validationResStyle}>
        <div className={cn(classes.header)}>
          <div className={classes.headerLeft}>
            <div className={cn(classes.flexRow, classes.searchTitle)}>Validation Results</div>
          </div>
          <div>
            <Visibility
              expand={expanded}
              onClick={() => {
                setExpanded(!expanded);
              }}
            />
          </div>
        </div>
        {expanded && (
          <div className={cn(classes.flexCol, classes.searchBody)}>
            {Object.keys(validationResults['claim']).length > 0 && <b>Claim Errors </b>}
            {Object.keys(validationResults['claim']).map((claimName: string) => {
              return (
                <div key={claimName} className={classes.compResult}>
                  <b>{claimName}</b>
                  {validationResults['claim'][claimName]['errors']?.length > 0 && (
                    <CollapseList
                      entries={validationResults['claim'][claimName]['errors']}
                      header={countAndPluralization(
                        validationResults['claim'][claimName]['errors'].length,
                        'Errors',
                        'Error',
                      )}
                      headerStyles={{ backgroundColor: '#f44336', marginLeft: '10px', marginRight: '10px' }}
                      onClick={() => {}}
                    />
                  )}
                  {validationResults['claim'][claimName]['warnings']?.length > 0 && (
                    <CollapseList
                      entries={validationResults['claim'][claimName]['warnings']}
                      header={countAndPluralization(
                        validationResults['claim'][claimName]['errors'].length,
                        'Warnings',
                        'Warning',
                      )}
                      headerStyles={{ backgroundColor: '#ffeb3b', marginLeft: '10px', marginRight: '10px' }}
                      onClick={() => {}}
                    />
                  )}
                  {Object.keys(validationResults).length > 1 && <Divider sx={{ mt: 1, mb: 1, bgcolor: 'black' }} />}
                </div>
              );
            })}

            {Object.keys(validationResults)
              .filter((val: string) => val !== 'claim')
              .map((fcId: string, fcIdx: number, fcArr) => {
                return (
                  <div key={fcId}>
                    <div className={cn(classes.flexRow, classes.flexWrap)}>
                      <b>Flowchart Name: {validationResults[fcId]['displayName']}</b>{' '}
                      <div
                        className={classes.pointer}
                        onClick={() => {
                          ['formSubmitAction', 'emailVerificationSendAction'].includes(
                            allFlowcharts[fcId].flowchartType,
                          )
                            ? dispatch(setCurrentFlowchartName(allFlowcharts[fcId]['parentFCId']))
                            : dispatch(setCurrentFlowchartName(fcId));
                          dispatch(setCurrentTabId(fcId));
                        }}
                      >
                        &nbsp;&nbsp;Click here to view
                      </div>
                    </div>
                    {Object.keys(validationResults[fcId]['components']).map((compId: string, idx: number) => {
                      return (
                        <div key={compId} className={cn(classes.compResult)}>
                          <b>{validationResults[fcId]['components'][compId]['name']}</b>
                          {validationResults[fcId]['components'][compId]['errors']?.length > 0 && (
                            <CollapseList
                              entries={validationResults[fcId]['components'][compId]['errors']}
                              header={countAndPluralization(
                                validationResults[fcId]['components'][compId]['errors'].length,
                                'Errors',
                                'Error',
                              )}
                              headerStyles={{ backgroundColor: '#f44336', marginLeft: '10px', marginRight: '10px' }}
                              onClick={() => {
                                ['formSubmitAction', 'emailVerificationSendAction'].includes(
                                  allFlowcharts[fcId].flowchartType,
                                )
                                  ? dispatch(setCurrentFlowchartName(allFlowcharts[fcId]['parentFCId']))
                                  : dispatch(setCurrentFlowchartName(fcId));
                                dispatch(setCurrentTabId(fcId));
                              }}
                            />
                          )}
                          {validationResults[fcId]['components'][compId]['warnings']?.length > 0 && (
                            <CollapseList
                              entries={validationResults[fcId]['components'][compId]['warnings']}
                              header={countAndPluralization(
                                validationResults[fcId]['components'][compId]['warnings'].length,
                                'Warnings',
                                'Warning',
                              )}
                              headerStyles={{ backgroundColor: '#ffeb3b', marginLeft: '10px', marginRight: '10px' }}
                              onClick={() => {
                                ['formSubmitAction', 'emailVerificationSendAction'].includes(
                                  allFlowcharts[fcId].flowchartType,
                                )
                                  ? dispatch(setCurrentFlowchartName(allFlowcharts[fcId]['parentFCId']))
                                  : dispatch(setCurrentFlowchartName(fcId));
                                dispatch(setCurrentTabId(fcId));
                              }}
                            />
                          )}
                          {idx < Object.keys(validationResults[fcId]['components']).length - 1 && (
                            <Divider sx={{ mt: 1, mb: 1 }} />
                          )}
                        </div>
                      );
                    })}
                    {fcIdx < fcArr.length - 1 && <Divider sx={{ mt: 1, mb: 1, bgcolor: 'black' }} />}
                  </div>
                );
              })}
          </div>
        )}
      </Box>
    </>
  );
}

// export default withAITracking(reactPlugin, JSONValidationComponent);
export default JSONValidationComponent;
